var map = {
	"./badge_fair_bronze.png": "bd29",
	"./badge_fair_gold.png": "ad52",
	"./badge_fair_silver.png": "48d7",
	"./badge_services_bronze.png": "45fa",
	"./badge_services_gold.png": "efe5",
	"./badge_services_silver.png": "6396",
	"./badge_software_bronze.png": "a94e",
	"./badge_software_gold.png": "7d5e",
	"./badge_software_silver.png": "bd4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd20";